module.exports = __webpack_public_path__ + "img/img-4.825d4e1c.jpg";